import { parse } from 'date-fns';
import _reverse from 'lodash/reverse';
import _sortBy from 'lodash/sortBy';

const API_DATE_FORMAT = 'MM/dd/yyyy hh:mm a';

export const sortRosterByAlpha = (roster, field = 'lastName') =>
  _sortBy(roster, [({ [field]: sortableField }) => sortableField && sortableField.toLowerCase()]);
export const sortRosterByVisits = roster => _reverse(_sortBy(roster, 'visitNumberToVenue'));
export const sortRosterByRecent = roster =>
  _reverse(_sortBy(roster, reservation => parse(reservation.dateCreated, API_DATE_FORMAT, new Date()).getTime()));
export const sortRosterByRatingHighToLow = roster => _reverse(_sortBy(roster, 'rateAverage'));
